import * as React from "react";
import { SvgIcon } from "@origin-digital/ods-icons";
import { ServiceTypeEnum } from "../../Premises/types";
import { UnreadMessageIcon } from "../../Projects/Icons";
import {
  RequestStatusCompletedIcon,
  RequestStatusAssignedIcon,
} from "../../Premises/Icons";
import { IconElectricityLocal } from "src/components/Icons";

export const GasIcon = () => (
  <SvgIcon titleAccess="Tasks Fuel Type Gas">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 3H8V5H16V3H18V5C19.1046 5 20 5.89543 20 7V12H20.25C20.6642 12 21 12.3358 21 12.75C21 13.1642 20.6642 13.5 20.25 13.5H20H18.5H5.5H4H3.75C3.33579 13.5 3 13.1642 3 12.75C3 12.3358 3.33579 12 3.75 12H4V7C4 5.89543 4.89543 5 6 5V3ZM18 6.5H6C5.72386 6.5 5.5 6.72386 5.5 7V12H18.5V7C18.5 6.72386 18.2761 6.5 18 6.5ZM20 14H4V19C4 20.1046 4.89543 21 6 21H18C19.1046 21 20 20.1046 20 19V14ZM8 8H6.5V10H8V8ZM9 8H10.5V10H9V8ZM13 8H11.5V10H13V8ZM14 8H15.5V10H14V8ZM18 8H16.5V10H18V8Z"
      fill="#505050"
    />
  </SvgIcon>
);

export const ExcelIcon = () => (
  <SvgIcon color="neutral" titleAccess="Tasks Excel">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 2h12c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2Zm0 14h12V4H8v12ZM2 6h2v14h14v2H4c-1.1 0-2-.9-2-2V6Zm10.897 6.715 1.035-1.725 1.02 1.71a.603.603 0 0 0 .525.3.57.57 0 0 0 .532-.307.568.568 0 0 0-.007-.608l-1.35-2.265 1.14-1.92c.12-.2.123-.4.008-.6a.56.56 0 0 0-.518-.3c-.11 0-.21.025-.3.075a.53.53 0 0 0-.21.21l-.84 1.365-.81-1.35a.603.603 0 0 0-.525-.3.558.558 0 0 0-.518.308.568.568 0 0 0 .008.607l1.155 1.905-1.35 2.28c-.12.2-.122.4-.008.6.115.2.288.3.518.3a.546.546 0 0 0 .495-.285Z"
    />
  </SvgIcon>
);

export const FilterIcon = () => (
  <SvgIcon color="secondaryB" titleAccess="Tasks Filter">
    <path d="M11 18H13C13.55 18 14 17.55 14 17C14 16.45 13.55 16 13 16H11C10.45 16 10 16.45 10 17C10 17.55 10.45 18 11 18ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7ZM7 13H17C17.55 13 18 12.55 18 12C18 11.45 17.55 11 17 11H7C6.45 11 6 11.45 6 12C6 12.55 6.45 13 7 13Z" />
  </SvgIcon>
);

export const SortResultIcon = () => (
  <SvgIcon color="neutral" titleAccess="Tasks Sort Result">
    <path d="M12.93 2.65c-.2-.2-.51-.2-.71 0l-2.01 2.01h4.72l-2-2.01Zm-.7 18.7c.2.2.51.2.71 0l1.98-1.98h-4.66l1.97 1.98Zm-1.25-3.62c.6 0 1.01-.6.79-1.16L8.04 7.03a1.205 1.205 0 0 0-2.24 0l-3.74 9.53c-.22.56.19 1.16.79 1.16.35 0 .67-.22.8-.55l.71-1.9h5.11l.71 1.9c.13.34.45.56.8.56Zm-6.01-4.09 1.94-5.18 1.94 5.18H4.97Zm16.08 2.5h-5.33l5.72-8.29c.46-.66-.02-1.57-.82-1.57h-6.48c-.44 0-.79.36-.79.8v.01c0 .44.36.8.79.8h5.09l-5.73 8.28c-.46.66.02 1.57.82 1.57h6.72c.44 0 .79-.36.79-.79a.776.776 0 0 0-.78-.81Z" />
  </SvgIcon>
);

export const PrintIcon = () => (
  <SvgIcon color="neutral" titleAccess="Tasks Print">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 8h1c1.66 0 3 1.34 3 3v6h-4v4H6v-4H2v-6c0-1.66 1.34-3 3-3h1V3h12v5Zm-2-3H8v3h8V5Zm0 14v-4H8v4h8Zm2-6v2h2v-4c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4h2v-2h12Zm1-1.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </SvgIcon>
);

export const ServiceTypeIcon = ({ serviceType }: { serviceType: string }) => {
  switch (serviceType) {
    case ServiceTypeEnum.ELECTRICITY:
      return <IconElectricityLocal color="neutral" />;
    case ServiceTypeEnum.GAS:
      return <GasIcon />;
    default:
      return null;
  }
};

export const TaskStatusIcon = ({ taskStatus }: { taskStatus: string }) => {
  switch (taskStatus) {
    case "envelope":
      return <UnreadMessageIcon />;
    case "connector":
      return <RequestStatusCompletedIcon />;
    case "assigned":
      return <RequestStatusAssignedIcon />;
    default:
      return null;
  }
};
